import { useEffect, useState } from "react";
import { 
  GetAlertsAction, 
  ToggleAlertAction 
} from "../../store/Actions/action";
import { useReduxStore } from "../../hooks/useReduxStore";
import { toast } from "react-toastify";
import useCurrentWeather from "../DashboardHome/useCurrentWeather";

const useAlertsList = () => {
  // const {place}=useCurrentWeather()
  const { getState, dispatch } = useReduxStore();
  
  const {
    alertsList,
    alertsLoading,
    currentPage,
    lastPage,
    totalAlertsCount,
    perPageCount,
  } = getState("Alerts");
  const {place}=getState("AUTH")
  const {isAdminLoggedIn}=getState("ADMIN_AUTH")
  
  const [searchTerm, setSearchTerm] = useState("");

  const onToggleAlert = (alertId, isActive) => {
    dispatch(ToggleAlertAction({ id: alertId, is_active: isActive }));
  };

  const onSearch = (search) => {
    setSearchTerm(search);
   const location = place ? `${place?.name||""},${place?.state||""}` : null;
    dispatch(GetAlertsAction({ page: 1, search,location }));
  };

  const onPageChange = (page) => {
   const location = place ? `${place?.name||""},${place?.state||""}` : null;
    dispatch(GetAlertsAction({ page, search: searchTerm,location }));
  };

  useEffect(() => {
    // dispatch(GetAlertsAction({ page: 1,isAdminLoggedIn }));
    if(place?.name){
   const location = place ? `${place?.name||""},${place?.state||""}` : null;
  dispatch(GetAlertsAction({ page: 1, location,isAdminLoggedIn }));
 }
  }, [place?.name]);

  return {
    alertsList,
    alertsLoading,
    currentPage,
    lastPage,
    totalAlertsCount,
    perPageCount,
    searchTerm,
    onToggleAlert,
    onSearch,
    onPageChange,
    setSearchTerm,
  };
};

export default useAlertsList;
